module.exports = __webpack_public_path__ + "static/img/rightlogob.3b01a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/rightlogob.png
// module id = ancL
// module chunks = 37